import {$dom} from "../helpers/dom";
import Component from "../classes/Component";
import {$events} from "../helpers/events";

const {addClass, get} = $dom

const previewGroupSelector = '.js-group-preview'
const fileInputSelector = '.js-file-input'

const deleteButtonSelector = '.js-delete-file'
const previewFileSelector = '.js-preview-file'

const threeHalfMbInBit = 29360128

export default function () {
    const handleDeletePreviewFile = (ev) => {
        const index = ev.target.dataset.index

        // get(fileInputSelector).files.splice(index, 1)

        ev.target.closest(previewFileSelector).remove()

    }

    const handleAddImages = (e) => {
        for (let i = 0; i < e.target.files.length; i++) {
            const file    = e.target.files[i];

            const reader  = new FileReader();

            reader.onload = function () {
                const img = new Image();

                img.src = reader.result.replace(/[\r\n]/g, "")

                addClass(img, 'file__loader-preview')

                get(previewGroupSelector).insertAdjacentHTML('beforeend', `
                    <div class="col-auto position-relative pe-0 js-preview-file">
                        <div class="${e.target.files[i].size > threeHalfMbInBit ? 'file__loader-error' : ''}">
                             ${img.outerHTML}
                            <div data-index="${i}" class="file__loader-preview-delete pt-1 text-center js-delete-file"> X </div>
                        </div>
                    </div>`
                )
            }

            if (file) {
                reader.readAsDataURL(file);
            }
        }


    }

    return new Component({
        name: 'addFile',
        requiredTargets: [fileInputSelector, previewGroupSelector],
        onInit() {
            $events.delegate
                .on('change', fileInputSelector, handleAddImages)
                .on('click', deleteButtonSelector, handleDeletePreviewFile)
        },
        onDestroy() {
            console.log('addFile')
        },
    })

}